import {
	ChangeDetectionStrategy,
	Component,
	OnInit
} from '@angular/core';
import type { CourseInvite } from '@dashboard/app/components/signup/course-invite';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SignupModule } from '../signup.module';
import { SignupMode } from '../signup-mode';
import { RouterService } from '@go-modules/services/router/router.service';
import { StateGoNamedParameters } from '../account-create/account-create.component';
import { SignupStateService } from '@dashboard/app/services/signup-state.service';
import { RegionSelectorService } from '@dashboard/app/services/region-selector.service';
import { RegionSelectorComponent } from '@dashboard/app/components/region-selector/region-selector.component';
import { LoadingModule } from '@go-modules/components/loading/loading.module';

@Component({
	selector: 'dashboard-signup-wrapper',
	imports: [SignupModule, RegionSelectorComponent, TranslateModule, LoadingModule],
	templateUrl: './dashboard-signup-wrapper.component.html',
	styleUrls: ['./dashboard-signup-wrapper.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardSignupWrapperComponent implements OnInit {
	public courseInvite: CourseInvite;
	public infoKey: string|null;
	public modes = SignupMode;

	constructor (
		private translateService: TranslateService,
		private routerService: RouterService,
		private signupStateService: SignupStateService,
		private regionSelectorService: RegionSelectorService
	) {}

	public ngOnInit () {
		this.infoKey = this.routerService.getCurrentQueryParams()['info-key'];
		// Get course invite data from the service
		const courseInvite = this.signupStateService.getCourseInvite();
		if (courseInvite) {
			this.courseInvite = courseInvite;
		}
		this.translateService.get('document-title_user-signup').subscribe((title: string) => {
			document.title = title;
		});
	}

	public navigate (location: StateGoNamedParameters): void {
		this.routerService.navigateTo(location.to, location.params);
	}

	public get showRegionSelector (): boolean {
		return this.regionSelectorService.showRegionSelector;
	}

	public get isRedirecting (): boolean {
		return this.regionSelectorService.isRedirecting;
	}
}
